import SelectOptionAsync from 'Component/Common/Select/SelectOptionAsync';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setFilters, resetFilters } from 'Services/Features/Order/orderSlice';
import { getBranch } from 'Services/Features/Branch/Utils/branchUtils';
import { getAllOrder } from 'Services/Features/Order/Utils/orderUtils';

const SelectBranch = () => {
    const dispatch = useDispatch();
    const dataBranch = useSelector(state => state.branch.branches);
    const filter = useSelector(state => state.order.filters);
    const [selectedValue, setSelectedValue] = useState(null);

    const handleChangeBranch = (selectedOption) => {
        console.log(selectedOption, 'selectedOption');
        setSelectedValue(selectedOption === null ? '' : selectedOption);
        dispatch(setFilters({
            ...filter,
            'page': 1,
            'filter[branch_id]': selectedOption ? selectedOption.value : ''
        }));
        dispatch(getAllOrder({
            ...filter,
            'page': 1,
            'filter[branch_id]': selectedOption ? selectedOption.value : ''
        }));
    };
    
    useEffect(() => {
        if (filter["filter[branch_id]"] === "") {
            setSelectedValue(null);
        } else {
            setSelectedValue({
                value: filter["filter[branch_id]"],
                label:
                    dataBranch.find(
                        (item) => item.id === filter["filter[branch_id]"]
                    )?.name || "",
            });
        }
    }, [filter["filter[branch_id]"]]);

    const promiseOptionBranch = (inputValue, callback) => {
        dispatch(getBranch({
            'filter[name]': inputValue,
            'sort': 'name',
            'page': 1,
        }))
            .then((response) => {
                const options = response.payload.data.map(item => ({
                    value: item.id,
                    label: item.name,
                }));
                callback(options);
            })
            .catch((error) => {
                console.error('Error fetching options:', error);
                callback([]);
            });
    };

    
    return (
        <SelectOptionAsync
            promiseOptions={promiseOptionBranch}
            handleChange={(selectedOption) => handleChangeBranch(selectedOption)}
            selectedValue={selectedValue}
            placeholder="Pilih Cabang"
            isMulti={false}
        />
    )
}

export default SelectBranch;
